// Trying to keep all the ugliness in one place.

var module = angular.module('octopusApp.infrastructure');

module.factory('sniffer', function(){
  var ie = navigator.appName === 'Microsoft Internet Explorer';
  var re  = new RegExp("MSIE 9\\.0");
  var ie9 = ie && re.exec(navigator.userAgent);
  return {
    isIE: ie,
    isIE9: ie9
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/sniffer.js
// module id = 6143675338771798
// module chunks = 1